export default __webpack_public_path__ + "static/media/Busy.e33baa17.svg";